<template>
    <div>
        <div>
            <el-form ref="form">
                <el-form-item>
                    <el-col class="line" :span="1" style="text-align: center">从</el-col>
                    <el-col :span="6">
                        <el-cascader filterable
                                     style="width: 100%;"
                                     :props="{ checkStrictly: true }"
                                     :options="areaList"
                                     v-model.trim="areaCode.sourceAreaCode"
                                     :clearable="false" size="small" placeholder="请选择源地区" @change="sourceHhandleChange">
                        </el-cascader>
                    </el-col>
                    <el-col class="line" :span="1" style="text-align: center">到</el-col>
                    <el-col :span="6">
                        <el-cascader filterable
                                     style="width: 100%;"
                                     :props="{ checkStrictly: true }"
                                     :options="areaList"
                                     v-model.trim="areaCode.destAreaCode"
                                     :clearable="false" size="small" placeholder="请选择目标地区" @change="destHandleChange">
                        </el-cascader>
                    </el-col>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <Evtable :header="tableHeader" :tools="tools" :actions="action"
                     :quickSearchKey="quickSearchKey"
                     :quickSearchPlaceholder="quickSearchPlaceholder"
                     :params="params"
                     :url="url"
                     @refresh = "copyfresh"
                     actionWidth="100"
                     :searchData="searchDatas"
                     @select="select"
                     @selectAll="select">
                <template slot="empty">
                    暂无数据！
                </template>
                <template slot="searchForm">

                    <el-col :span="12">
                        <el-form-item label="模型编码" prop="search_LIKE_modelCode">
                            <el-input v-model.trim="searchDatas.search_LIKE_modelCode"
                                      placeholder="请输入模型编码"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="模型名称" prop="search_LIKE_modelName">
                            <el-input v-model.trim="searchDatas.search_LIKE_modelName"
                                      placeholder="请输入模型名称">
                            </el-input>
                        </el-form-item>
                    </el-col>

                </template>
            </Evtable>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import ElCascaderMenu from "../../../../packages/components/cascader/src/menu";
    export default {
        components: {ElCascaderMenu, Treeselect},
        props: ["selectMenuId","areaList","dialogTableVisible"],
        data(){
            const that = this;
            return {
                refresh: "",
                areaCode:{
                    sourceAreaCode:'',
                    destAreaCode:''
                },
                userAreaCode:that.request.getSession('userInfo').org.areaCode,
                tableHeader: [
                    {
                        type: "check",
                        align: "center",
                        selectable:function (a,b) {
                            let isSelect = a.isSelect;
                            let result = true;
                            if(isSelect=="true"){
                                result = false ;
                            }
                            return result;
                        }
                    }, {
                        label: "模型编码",
                        align: "center",
                        prop: "modelCode",
                        width: "80"
                    },  {

                        label: "模型名称",
                        align: "center",
                        prop: "modelName",

                    }
                ],
                searchDatas: {
                    search_LIKE_modelCode: '',
                    search_LIKE_modelName: ''
                },
                quickSearchKey: "search_LIKE_modelName",
                quickSearchPlaceholder: "请输入模型名称",
                url:'/bigdata-visual/modelbase/vsDsModel/queryModelCopyByMenuId',
                params:{menuId:this.selectMenuId,sourceAreaCode:'',destAreaCode:''},
                action:[],
                tools: [{
                    name: 'modelCreate:pc',
                    text: '批量复制',
                    click: function (a, refesh) {
                        let selected = [];
                        if (that.selected!=null&&that.selected!=""&&that.selected.length>0) {
                            for (let i=0;i<that.selected.length;i++){
                                selected.push(that.selected[i].modelId);
                            }
                        }else{
                            that.$message.error("请选择至少一项");
                            return;
                        }
                        that.$confirm('确认要复制这些模型吗?', '操作确认', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            that.request.get("/bigdata-visual/modelbase/vsDsModel/modelCopyByMenuId/",{
                                modelIds:selected.join(),
                                destAreaCode:that.params.destAreaCode
                            }).then(res => {
                                if (res.status === 1) {
                                    that.$message.success("批量复制成功");
                                    that.$emit('pcopy',"子组件向父组件发送消息");//子组件向父组件发送消息
                                    that.refresh();
                                    that.selected = [];
                                } else {
                                    that.$message.error("批量复制失败");
                                }
                            }).catch(error => {
                                console.log(error);
                            });
                        }).catch(() => {
                            that.$message({
                                type: 'info',
                                message: '已取消复制'
                            });
                        });
                    }
                }]
            }
        },
        methods:{
            sourceHhandleChange(value){

            },
            destHandleChange(value){

            },
            select(e){
                this.selected = e;
            },
            copyfresh(e){
                this.refresh= e;
            },
            sourceIni(){
                let areaCode = [];
                if(this.userAreaCode!=null&&this.userAreaCode!=''){
                    if(this.userAreaCode.length==2){
                        areaCode.push(this.userAreaCode.substr(0,2));
                    }else if(this.userAreaCode.length==4){
                        areaCode.push(this.userAreaCode.substr(0,2));
                        areaCode.push(this.userAreaCode.substr(2,2));
                    }else if(this.userAreaCode.length==6){
                        areaCode.push(this.userAreaCode.substr(0,2));
                        areaCode.push(this.userAreaCode.substr(2,2));
                        areaCode.push(this.userAreaCode.substr(4,2));
                    }
                }
                return areaCode;
            }
        },
        watch:{
            dialogTableVisible(newType,oldType){
                this.areaCode.destAreaCode = '';
            },
            areaIsSelect(newType,oldType){
                let that = this;
                if(newType.length>=2){
                    let params = {menuId:that.selectMenuId,
                        sourceAreaCode:this.areaCode.sourceAreaCode.join("").padEnd(6,'0'),
                        destAreaCode:this.areaCode.destAreaCode.join("").padEnd(6,'0')};
                    that.params = params
                }
            }
        },
        computed:{
            areaIsSelect() {
                let areaCode=[];
                if(this.areaCode.sourceAreaCode!=null&&this.areaCode.sourceAreaCode!=''&&this.areaCode.sourceAreaCode.length>0){
                    areaCode.push(this.areaCode.sourceAreaCode);
                }
                if(this.areaCode.destAreaCode!=null&&this.areaCode.destAreaCode!=''&&this.areaCode.destAreaCode.length>0){
                    areaCode.push(this.areaCode.destAreaCode);
                }
                return areaCode;
            }
        },
        created() {
            let areaCode = this.sourceIni();
            this.areaCode.sourceAreaCode = areaCode;
        }
    }
</script>

<style>
    #model-create-copy>.el-dialog{
        height: 650px;
        width: 800px;
        margin-top: 0 !important;
    }
    .is-disabled .el-checkbox__inner{
        cursor: not-allowed;
    }
</style>

